import React, { useState } from 'react';
import Select from 'react-select';

const ScoringSetup = ({ game, onSetupComplete }) => {
    const [setupData, setSetupData] = useState({
        battingTeamId: null,
        bowlingTeamId: null,
        strikerId: null,
        nonStrikerId: null,
        bowlerId: null,
    });

    const handleSetupChange = (name, selectedOption) => {
        // When changing batting or bowling team, reset player selections
        if (name === 'battingTeamId') {
            setSetupData(prev => ({ ...prev, strikerId: null, nonStrikerId: null, [name]: selectedOption }));
        } else if (name === 'bowlingTeamId') {
            setSetupData(prev => ({ ...prev, bowlerId: null, [name]: selectedOption }));
        } else {
            setSetupData(prev => ({ ...prev, [name]: selectedOption }));
        }
    };

    const handleStartScoring = () => {
        if (!setupData.battingTeamId || !setupData.bowlingTeamId || !setupData.strikerId || !setupData.nonStrikerId || !setupData.bowlerId) {
            alert("Please fill all setup fields.");
            return;
        }
        const battingTeam = game.teams.find(t => t.id === setupData.battingTeamId.value);
        const bowlingTeam = game.teams.find(t => t.id === setupData.bowlingTeamId.value);

        onSetupComplete({
            striker: battingTeam.players.find(p => p.id === setupData.strikerId.value),
            nonStriker: battingTeam.players.find(p => p.id === setupData.nonStrikerId.value),
            bowler: bowlingTeam.players.find(p => p.id === setupData.bowlerId.value),
        });
    };

    const teamOptions = game.teams.map(t => ({ value: t.id, label: t.name }));
    const battingTeamPlayers = game.teams.find(t => t.id === setupData.battingTeamId?.value)?.players.map(p => ({ value: p.id, label: p.player_name })) || [];
    const bowlingTeamPlayers = game.teams.find(t => t.id === setupData.bowlingTeamId?.value)?.players.map(p => ({ value: p.id, label: p.player_name })) || [];
    
    // Custom styles for react-select to match the dark theme
    const selectStyles = {
        control: (styles) => ({ ...styles, backgroundColor: '#34495e', border: '1px solid #4a6a8a', color: 'white' }),
        option: (styles, { isFocused }) => ({ ...styles, backgroundColor: isFocused ? '#4a6a8a' : '#34495e', color: 'white' }),
        singleValue: (styles) => ({ ...styles, color: 'white' }),
        menu: (styles) => ({ ...styles, backgroundColor: '#34495e' }),
        input: (styles) => ({...styles, color: 'white'}),
    };

    return (
        <div className="scoring-setup-container">
            <div className="scoring-setup-card">
                <h3 className="text-center mb-4">Pre-Game Setup</h3>
                <div className="row">
                    <div className="col-md-6 form-group">
                        <label>Batting Team</label>
                        <Select styles={selectStyles} options={teamOptions} value={setupData.battingTeamId} onChange={(opt) => handleSetupChange('battingTeamId', opt)} />
                    </div>
                    <div className="col-md-6 form-group">
                        <label>Bowling Team</label>
                        <Select styles={selectStyles} options={teamOptions.filter(t => t.value !== setupData.battingTeamId?.value)} value={setupData.bowlingTeamId} onChange={(opt) => handleSetupChange('bowlingTeamId', opt)} />
                    </div>
                </div>
                <hr className="my-4" />
                <div className="row">
                    <div className="col-md-6 form-group">
                        <label>Striker</label>
                        <Select styles={selectStyles} options={battingTeamPlayers} value={setupData.strikerId} onChange={(opt) => handleSetupChange('strikerId', opt)} />
                    </div>
                    <div className="col-md-6 form-group">
                        <label>Non-Striker</label>
                        <Select styles={selectStyles} options={battingTeamPlayers.filter(p => p.value !== setupData.strikerId?.value)} value={setupData.nonStrikerId} onChange={(opt) => handleSetupChange('nonStrikerId', opt)} />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-12 form-group">
                        <label>Opening Bowler</label>
                        <Select styles={selectStyles} options={bowlingTeamPlayers} value={setupData.bowlerId} onChange={(opt) => handleSetupChange('bowlerId', opt)} />
                    </div>
                </div>
                <div className="text-center mt-4">
                    <button className="btn-start-scoring" onClick={handleStartScoring}>Start Scoring</button>
                </div>
            </div>
        </div>
    );
};

export default ScoringSetup;

